<template>

  <v-card flat>

    <v-dialog v-model="dMostrarNuevaAgrupacion" max-width="400px">
      <v-card flat>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 md11>
              <v-text-field color="green darken-1" :label="$t('nombreNuevaAgrupacion')" v-model="dAgrupaDenominacion"
                :rules="[rules.checkAgrupacion]"></v-text-field>
            </v-flex>
            <v-flex xs12 md1>
              <v-tooltip bottom>
                <v-btn slot="activator" flat color="green darken-1  white--text" icon class="mx-0"
                  @click="fCreaAgrupacion(); dMostrarNuevaAgrupacion = false" style="margin-top:15px">
                  <v-icon>mdi-check</v-icon>
                </v-btn>
                <span>{{ $t('crear') }}</span>
              </v-tooltip>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- dialogo para la gestión de grupos -->
    <v-dialog v-model="dMostrarAlertaBorradoAgrupaciones" persistent max-width="370">
      <v-card>
        <v-card-title class="subheading" style="text-align: center; padding: 25px 15px;">{{
          $t('checkBorradoAgrupaciones') }}</v-card-title>
        <v-card-actions style="background-color: #eee;padding: 15px">
          <v-spacer></v-spacer>
          <v-btn color="green darken-1  white--text" @click="dMostrarAlertaBorradoAgrupaciones = false">{{ $t('no')
            }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1  white--text"
            @click="fBorradoAgrupaciones(); dMostrarAlertaBorradoAgrupaciones = false">{{ $t('si') }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- cabecera del dialogo -->
    <v-card-title style="background-color: #43A047; color: #fff; padding: 15px;">
      <div style='width:100% '>
        <div style="float: left;">
          <span class="headline">{{ $t('agrupaciones') }}</span>
        </div>
        <div style="float: right; margin-top: -10px; margin-right: -10px">
          <v-btn flat icon color="white" @click="fCerrarVentana()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </div>
    </v-card-title>

    <v-card-text style="padding:0px;">
      <DataTable @select="fSelectAgrupacion" @recharge="fCargarListaAgrupaciones" :dataTableId="dDataTableId"
        :headers="dHeadersAgrupaciones" :items="dItemsAgrupacion" :totalItems="dTotalItemsAgrupacion" :rowsPerPage="5"
        :loading="dLoadingAgrupaciones" :checkboxOn="true">
      </DataTable>
    </v-card-text>

    <!-- botonera de acciones -->
    <v-card-actions style="background-color: #eee;padding: 15px">
      <v-spacer></v-spacer>
      <v-tooltip bottom style="position:absolute;top:95px;left:30px">
        <v-btn slot="activator" flat color="green darken-1  white--text" icon class="mx-0"
          @click="dMostrarNuevaAgrupacion = true">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <span>{{ $t('crear') }}</span>
      </v-tooltip>
      <v-tooltip bottom style="position:absolute;top:95px;left:70px">
        <v-btn slot="activator" flat color="green darken-1  white--text" icon class="mx-0"
          @click="fCheckBorradoAgrupaciones()">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
        <span>{{ $t('borrar') }}</span>
      </v-tooltip>
      <v-btn color="green darken-1  white--text" @click="fCerrarVentana()">
        <v-icon>mdi-arrow-left</v-icon>
        <span>{{ $t('salir') }}</span>
      </v-btn>
    </v-card-actions>

  </v-card>

</template>

<script>

import DataTable from '@/components_datadec/DataTable'
import NumberTextFieldSpinner2Vue from '../../../components_datadec/NumberTextFieldSpinner2.vue'

// SERVICES
import SrvPres from '@/services/srv-presupuestos'

export default {
  name: 'PreAgrupaciones',
  components: {
    DataTable
  },
  props: {
    pPresupuestoAsistente: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dDataTableId: 'AGRUPACIONES',
      dPresupuestoAsistentePaso3: this.pPresupuestoAsistente,
      dMostrarNuevaAgrupacion: false,
      dTotalItemsAgrupacion: 0,
      dAgrupaDenominacion: null,
      dLoadingAgrupaciones: false,
      dItemsAgrupacion: [],
      dAgrupacionesSeleccionadas: null,
      dMostrarAlertaBorradoAgrupaciones: false,
      dHeadersAgrupaciones: [
        { text: this.$t('agrupacion'), align: 'left', value: 'agrupaDenominacion', column: 'agrupaDenominacion' }
      ],
      rules: {
        checkAgrupacion: (value) => {
          return ((this.dAgrupaDenominacion !== undefined) && (this.dAgrupaDenominacion !== null)) ? true : this.$t('campoRequerido')
        }
      }
    }
  },
  created() {
    this.fCargaAgrupaciones('agrupaDenominacion', false, 1, 10, '', null)
  },
  methods: {
    fCargarListaAgrupaciones(parametros) {
      if (this.dPresupuestoAsistentePaso3.empresa != null) {
        this.fCargaAgrupaciones(parametros.sortBy, parametros.descending, parametros.page, parametros.rowsPerPage, parametros.search, parametros.filters)
      }
    },
    fSelectAgrupacion(agrupaciones) {
      this.dAgrupacionesSeleccionadas = agrupaciones
    },
    /**
     * Metodo para cerrar la ventana
     */
    fCerrarVentana() {
      this.$emit('close')
    },
    /**
     * Carga las agrupaciones
     */
    fCargaAgrupaciones(sortBy, descending, page, rowsPerPage, search, filters) {
      let offset = 1
      const order = (descending) ? 'DESC' : 'ASC'

      if (sortBy === undefined || sortBy === '1') {
        sortBy = 'agrupaDenominacion'
      }

      if (page === undefined) {
        page = 1
      }
      if (rowsPerPage === undefined) {
        rowsPerPage = this.rowsPerPage
      }
      offset = rowsPerPage * (page - 1) + 1
      const payload = {
        usuario: this.$store.getters.getAutenticacion.usuario,
        tira: this.$store.getters.getAutenticacion.tira,
        agrupaEmpresa: this.$store.getters.getAutenticacion.empresa,
        search: search,
        offset: offset,
        numRows: rowsPerPage,
        orderBy: sortBy,
        order: order,
        filters: filters
      };
      SrvPres.getAgrupaciones(payload).then(response => {
        if (response.data.statusCode === '200') {
          const dataAgrupaciones = response.data
          this.dItemsAgrupacion = dataAgrupaciones.AGRUPACIONES
          this.dItemsAgrupacion.map((agrupacion) => {
            agrupacion.id = agrupacion.agrupaCodigo
          })
          this.dTotalItemsAgrupacion = dataAgrupaciones.totalRows
        } else {
          this.$emit('alert', '<b>obtiene las agrupaciones</b><br> ' + response.data.statusText + '  (' + response.data.statusCode + ' ) ')
        }
      }).catch(error => {
        this.fErrorComprobado(error)
      })
    },
    /**
     * Metodo que crea una agrupacion
     */
    fCreaAgrupacion() {
      this.dMostrarNuevaAgrupacion = false
      this.dLoadingAgrupaciones = true
      const payload = {
        usuario: this.$store.getters.getAutenticacion.usuario,
        tira: this.$store.getters.getAutenticacion.tira,
        agrupaEmpresa: this.$store.getters.getAutenticacion.empresa,
        agrupaDenominacion: this.dAgrupaDenominacion
      }
      SrvPres.saveAgrupacion(payload).then(response => {
        if (response.data.statusCode === '200') {
          this.fCargaAgrupaciones('agrupaDenominacion', false, 1, 10, '', null)
          this.dAgrupaDenominacion = ''
        } else {
          this.$emit('alert', '<b>guarda una agrupacion</b><br> ' + response.data.statusText + '  (' + response.data.statusCode + ' ) ')
        }
      }).catch(error => {
        this.fErrorComprobado(error)
      })
    },
    /*
     * comprueba si puede borrar
     */
    fCheckBorradoAgrupaciones() {
      // Comprueba si se ha seleccionado algo
      if (this.dAgrupacionesSeleccionadas && this.dAgrupacionesSeleccionadas.length > 0) {
        this.dMostrarAlertaBorradoAgrupaciones = true
      } else {
        this.$emit('alert', this.$t('noSeleccion'))
      }
    },
    /**
     * Metodo que borra una agrupacion
     */
    fBorradoAgrupaciones() {
      if ((this.dAgrupacionesSeleccionadas !== undefined) && (this.dAgrupacionesSeleccionadas !== null)) {
        for (let i = 0; i < this.dAgrupacionesSeleccionadas.length; i++) {
          const agrupacion = this.dAgrupacionesSeleccionadas[i]
          this.dLoadingAgrupaciones = NumberTextFieldSpinner2Vue
          const payload = {
            usuario: this.$store.getters.getAutenticacion.usuario,
            tira: this.$store.getters.getAutenticacion.tira,
            agrupaEmpresa: this.$store.getters.getAutenticacion.empresa,
            agrupaCodigo: agrupacion.agrupaCodigo
          }
          SrvPres.deleteAgrupacion(payload).then(response => {
            if (response.data.statusCode === '200') {
              this.fCargaAgrupaciones('agrupaDenominacion', false, 1, 10, '', null)
            } else {
              this.$emit('alert', '<b>borra una agrupacion</b><br> ' + response.data.statusText + '  (' + response.data.statusCode + ' ) ')
            }
          }).catch(error => {
            this.fErrorComprobado(error)
          })
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.buttonBar .card__title {
  padding: 8px !important;
}

.buttonBarSearch .card__title {
  padding: 0px !important;
}

.buttonBarSearchTop .card__text {
  padding-top: 4px !important;
  padding-bottom: -10px !important;
}

.numberInputSpinnerInput .vnis__input {
  background: #ffffff !important;
  border: 0px !important;
  border-bottom: 1px solid #999999 !important;
}

.numberInputSpinnerButton .vnis__button {
  background: #ffffff !important;
  color: #000000 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Informes/Presupuestos/ShpAgrupaciones.vue